import React, { useState, useEffect } from "react";
import {
    SlButton,
    SlSectionTitle,
    SlBusyIndicator
} from "./editors";
import { registrationService, metadataService, userService, LoanInfoApi } from "../_services";
import { history } from "../_helpers";
import { Alert, Row } from "reactstrap";
import { SelectLoan, SelectPaymentAmount, SelectPaymentMethod, RePay, PayNearMe, MakePaymentVerifyIdentity, PaymentSuccess } from "./subcomponents";
import { newLoanActions } from "../_actions";
import { connect } from 'react-redux';

const MakePayment = (props) => {
    const STEP_START = "";
    const STEP_IDENTIFY = "IDENTIFY";
    const STEP_SELECT_LOAN = "SELECT_LOAN";
    const STEP_PAYMENT_DETAILS = "PAYMENT_DETAILS";
    const STEP_PROCESSOR = "PROCESSOR";
    const STEP_PROCESSOR_CONFIRMATION = "PROCESSOR_CONFIRMATION";
    const STEP_COMPLETE = "COMPLETE";

    const PROCESSOR_REPAY = "Repay";
    const PROCESSOR_PAYNEARME = "PayNearMe";

    const [isBusy, setIsBusy] = useState(true);
    const [currentStep, setCurrentStep] = useState(STEP_START);

    const [payableLoans, setPayableLoans] = useState([]);
    const [loanToPay, setLoanToPay] = useState(null);
    const [paymentSessionId, setPaymentSessionId] = useState(null);

    const [paymentAmount, setPaymentAmount] = useState({});
    const [processorRequest, setProcessorRequest] = useState({});
    const [processorResponse, setProcessorResponse] = useState({});

    const [paymentUser, _setPaymentUser] = useState({
        userId: null,
        userHash: null,
        ssn: null,
        dob: null,
        hasAccount: false
    });
    const setPaymentUser = async (user) => {
        if (user.userId === null && user.userHash !== null) {
            var hashResponse = await userService.isHashInUse(user.userHash);
            user.hasAccount = hashResponse.data;
        } else {
            user.hasAccount = user.userId !== null;
        }
        _setPaymentUser(user);
    }

    useEffect(() => {
        const currentUser = userService.getCurrentUser();
        if (currentUser) {
            setPaymentUser({ userId: currentUser.user.userId });
        } else {
            setCurrentStep(STEP_IDENTIFY);
        }

        setIsBusy(false);
    }, []);

    useEffect(() => {
        setLoanToPay(null);
        setPayableLoans([]);

        if (paymentUser !== null)
            startPaymentSession(paymentUser);
    }, [paymentUser]);

    useEffect(() => {
        if (loanToPay !== null) {
            setCurrentStep(STEP_PAYMENT_DETAILS);
        } 
    }, [loanToPay]);

    const selectLoan = (loanId) => {
        setLoanToPay(
            payableLoans.find(l => l.currentLoanId === parseInt(loanId, 10))
        );
    };

    const startPaymentSession = async (user) => {
        setIsBusy(true);
        setPaymentSessionId(null);

        var paymentSession = null;

        if (user.userId !== null) {
            paymentSession = await LoanInfoApi.startPayment();
        } else if (user.userHash !== null) {
            paymentSession = await LoanInfoApi.startGuestPayment(user.userHash);
        }

        if (paymentSession !== null && paymentSession.data !== null) {
            setPayableLoans(paymentSession.data.paymentInfo);

            if (paymentSession.data.paymentInfo.length === 1) {
                setLoanToPay(paymentSession.data.paymentInfo[0]);
            } else if (props.match.params.id) {
                setLoanToPay(paymentSession.data.paymentInfo.find(x => x.currentLoanId == props.match.params.id));
            }
            else {
                setCurrentStep(STEP_SELECT_LOAN);
            }
        }

        setIsBusy(false);
    };

    const canMoveNext = () => {
        switch (currentStep) {
            case STEP_PROCESSOR_CONFIRMATION:
            case STEP_COMPLETE:
                return true;
            case STEP_IDENTIFY:
                return paymentUser.ssn && paymentUser.dob;
            case STEP_SELECT_LOAN:
                return loanToPay !== null;
            case STEP_PAYMENT_DETAILS:
                return paymentAmount > 0 && paymentAmount <= loanToPay.payoff;
            default:
                return false;
        }
    };

    const onNext = () => {
        switch (currentStep) {
            case STEP_IDENTIFY:
                setIsBusy(true);
                registrationService.getUserHash({
                    DateOfBirth: paymentUser.dob,
                    SSN: paymentUser.ssn,
                }).then(response => {
                    if (response.data) {
                        _setPaymentUser({ userHash: response.data, userId: null })
                    } else {
                        setPaymentUser(null);
                    }
                    setIsBusy(false);
                });
                break;
            case STEP_SELECT_LOAN:
                setCurrentStep(STEP_PAYMENT_DETAILS);
                break;
            case STEP_PAYMENT_DETAILS:
                setIsBusy(true);
                LoanInfoApi.getPaymentProcessor(
                    loanToPay.currentLoanId,
                    paymentAmount,
                    paymentUser.userHash,
                    processorRequest
                ).then(response => {
                    if (response.data) {
                        setProcessorResponse(response.data.processorData);
                        setPaymentSessionId(response.data.paymentSessionId);
                    } else {
                        setProcessorResponse(null);
                    }
                    setCurrentStep(STEP_PROCESSOR);
                    setIsBusy(false);
                });
                break;
            case STEP_PROCESSOR_CONFIRMATION:
                if (paymentUser.userId !== null) {
                    history.push('/my-account');
                } else {
                    setCurrentStep(STEP_COMPLETE);
                }
                break;
            default:
                break;
        }
    };
    const onBack = () => {
        setIsBusy(false);
        switch (currentStep) {
            case STEP_PAYMENT_DETAILS:
                setCurrentStep(STEP_SELECT_LOAN);
                break;
            case STEP_PROCESSOR:
                setCurrentStep(STEP_PAYMENT_DETAILS);
                break;
            default:
                break;
        }
    };

    const onProcessorMessage = (data) => {
        if (data === "PAYMENT_COMPLETE") {
            LoanInfoApi.setPaymentSession(paymentSessionId, true).then(
                e => {
                    if (paymentUser.userId !== null) {
                        history.push('/my-account');
                    } else {
                        setCurrentStep(STEP_COMPLETE);
                    }
                }
            );
        } else if (data === "PAYMENT_SUCCESS") {
            LoanInfoApi.setPaymentSession(paymentSessionId, true).then(
                e => {
                    setCurrentStep(STEP_PROCESSOR_CONFIRMATION);
                }
            );
        } else if (data === "PAYMENT_ERROR") {
            LoanInfoApi.setPaymentSession(paymentSessionId, false);
        } else if (data === "PAYMENT_CANCEL") {
            onBack();
        }
    };


    if (isBusy)
        return <SlBusyIndicator visible="true" />

    return (
        <div>
            {currentStep === STEP_COMPLETE &&
                <PaymentSuccess hasAccount={paymentUser.hasAccount} userHash={paymentUser.userHash} />
            }

            {currentStep === STEP_IDENTIFY &&
                <MakePaymentVerifyIdentity onChange={({ ssn, dob }) => setPaymentUser({ ssn, dob, userHash: null, userId: null, hasAccount: false })}/>
            }

            {currentStep === STEP_SELECT_LOAN && payableLoans.length === 0 &&
                <Alert color='danger'>
                    <div className='p-3' dangerouslySetInnerHTML={{ __html: metadataService.getMessage("ErrorCannotFindLoan") }}></div>
                </Alert>
            }
            {currentStep === STEP_SELECT_LOAN && payableLoans.length > 0 && 
                <React.Fragment>
                    <SlSectionTitle sectionName="SelectLoan" />
                    { payableLoans.map(e => {
                        return (
                            <SelectLoan
                                key={e.currentLoanId}
                                loan={e}
                                onLoanSelected={selectLoan}
                                isSelected={
                                    loanToPay != null && e.currentLoanId === loanToPay.currentLoanId
                                }
                            />
                        );
                    })}
                </React.Fragment>
            }

            {currentStep === STEP_PAYMENT_DETAILS && loanToPay === null &&
                <Alert color='danger' className="w-100">{metadataService.getMessage("UnableToCompleteRequest")}</Alert>
            }
            {currentStep === STEP_PAYMENT_DETAILS && loanToPay !== null &&
                <React.Fragment>
                    <SlSectionTitle sectionName="SelectPayment" />
                    <h4 className="padLeft3Rem">{metadataService.getMessage('LoanNumber', metadataService.maskExceptLastFourCharacters(loanToPay.currentLoanId.toString()))}</h4>
                    <p class="text-center">{metadataService.getMessage('ACHpayment')}</p>
                    {loanToPay.latestAchReturned && (
                        <Row >
                            <Alert color='warning' className="w-100">{metadataService.getMessage('ACHPaymentFailed')}</Alert>
                        </Row>
                    )}

                    <SelectPaymentAmount
                        loanToPay={loanToPay}
                        onAmountChange={setPaymentAmount}
                    />


                    {(loanToPay.debitProcessor === PROCESSOR_REPAY || loanToPay.achProcessor === PROCESSOR_REPAY) &&
                        <SelectPaymentMethod
                            enableAchPayments={loanToPay.achProcessor === PROCESSOR_REPAY}
                            processor={PROCESSOR_REPAY}
                            onPaymentMethodChange={setProcessorRequest} />
                    }

                </React.Fragment>
            }

            {currentStep.startsWith(STEP_PROCESSOR) && 
                <React.Fragment>
                    {processorResponse === null && 
                        <Alert color='danger' className="w-100">{metadataService.getMessage("UnableToCompleteRequest")}</Alert>    
                    }    

                    {(loanToPay.achProcessor === PROCESSOR_PAYNEARME || loanToPay.debitProcessor === PROCESSOR_PAYNEARME) && processorResponse !== null ?
                        <PayNearMe
                            embeddedClientUrl={processorResponse.embeddedClientUrl}
                            paymentAmount={processorResponse.paymentAmount}
                            smartToken={processorResponse.smartToken}
                            allowAch={loanToPay.achProcessor === PROCESSOR_PAYNEARME}
                            allowDebit={loanToPay.debitProcessor === PROCESSOR_PAYNEARME}
                            allowPayPal={loanToPay.payPalProcessor === PROCESSOR_PAYNEARME}
                            allowGooglePay={loanToPay.googlePayProcessor === PROCESSOR_PAYNEARME}
                            allowApplyPay={loanToPay.applePayProcessor === PROCESSOR_PAYNEARME}
                            allowVenmo={loanToPay.venmoProcessor === PROCESSOR_PAYNEARME}
                            allowCash={loanToPay.cashProcessor === PROCESSOR_PAYNEARME}
                            allowCashApp={loanToPay.cashAppProcessor === PROCESSOR_PAYNEARME}
                            onMessage={onProcessorMessage} />
                        :
                        <RePay paymentUrl={processorResponse.paymentUrl} onMessage={onProcessorMessage} />
                    }
                </React.Fragment>    
            }

            {currentStep !== STEP_COMPLETE && (
                <div>
                    <div className="text-center">
                        { currentStep !== STEP_IDENTIFY && currentStep !== STEP_SELECT_LOAN && currentStep !== STEP_PROCESSOR_CONFIRMATION && (
                            <SlButton name="Back" onClick={onBack} />
                        )}
                        { currentStep !== STEP_PROCESSOR && (
                            <SlButton
                                name="Next"
                                onClick={onNext}
                                disabled={!canMoveNext()}
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            unableToFindAccount: () => {
                dispatch(newLoanActions.accountNotFound(metadataService.getMessage("ErrorCannotFindLoan")));
            }
        }
    };
}

const connectedMakePayment = connect(
    mapDispatchToProps,
)(MakePayment);

export { connectedMakePayment as MakePayment };